import React from 'react';
import { Helmet } from 'react-helmet';
import Footer from './Footer';
import Navbar from './Navbar';
import '../scss/all.scss';
import useSiteMetadata from './SiteMetadata';
import { withPrefix } from 'gatsby';

const Layout = ({ children }) => {
  const { title, description } = useSiteMetadata();
  return (
    <div className="main">
      <Helmet>
        <html lang="en" />
        <title>{title}</title>
        <meta name="description" content={description} />
        <link
          href="https://fonts.googleapis.com/css2?family=Cookie&family=Courgette&family=Kalam:wght@400;700&family=Montserrat&display=swap"
          rel="stylesheet"
        />
        <link
          rel="icon"
          type="image/png"
          href={`${withPrefix('/')}img/icons8-church-24.png`}
          sizes="32x32"
        />
        <link
          rel="icon"
          type="image/png"
          href={`${withPrefix('/')}img/icons8-church-24.png`}
          sizes="16x16"
        />

        <link rel="mask-icon" href={`${withPrefix('/')}img/icons8-church-24.png`} color="#ff4400" />
        <meta name="theme-color" content="#fff" />

        <meta property="og:type" content="business.business" />
        <meta property="og:title" content={title} />
        <meta property="og:url" content="/" />
        <meta property="og:image" content={`${withPrefix('/')}img/church.jpg`} />
      </Helmet>
      <Navbar />
      <div className="positive-flex">{children}</div>
      <Footer />
    </div>
  );
};

export default Layout;
